/**
 * html5上传控件
 */

import CONST from './const';
import JpegMeta from './lib/jpegMeta';
import sha1Wasm from './lib/sha1-wasm';

function toUrlParams(obj) {
  let arr = [],
    k;
  for (k in obj) {
    if (obj.hasOwnProperty(k)) arr.push(encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]));
  }

  return arr.join('&');
}

function isType(type) {
  return function(value) {
    return Object.prototype.toString.call(value) === '[object ' + type + ']';
  };
}

export const isFunction = isType('Function');

export const isObject = isType('Object');

export const isString = isType('String');

export const isNumber = isType('Number');

export const isArray = Array.isArray || isType('Array');

export const isPlainObject = function(obj) {
  return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
};

export const extend = function(deep, target) {
  let sources = Array.prototype.slice.call(arguments, 2);
  let source;

  for (let i = 0; i < sources.length; i++) {
    source = sources[i];
    for (let key in source) {
      if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
        if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
          target[key] = {};
        }

        if (isArray(source[key]) && !isArray(target[key])) {
          target[key] = [];
        }

        extend(deep, target[key], source[key]);
      } else if (source[key] !== undefined) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

export const cookie = function(name) {
  let value = '; ' + document.cookie;
  let parts = value.split('; ' + name + '=');
  if (parts.length == 2)
    return parts
      .pop()
      .split(';')
      .shift();
};

export const getUin = (function() {
  let uin;

  return function() {
    if (uin) return uin;

    if ((uin = cookie('uin'))) {
      uin = parseInt(uin.replace('o', ''), 10);
    } else if ((uin = cookie('p_uin'))) {
      uin = parseInt(uin.replace('o', ''), 10);
    }

    return uin;
  };
})();

export const client = (function() {
  let ua = navigator.userAgent || '';
  let isWX = ua.match(/MicroMessenger\/([\d\.]+)/), //微信
    isQQ = ua.match(/QQ\/([\d\.]+)/), //手Q
    isQzone = ua.match('Qzone'); //手空

  let rs;

  if (isQQ) {
    rs = 'qq';
  } else if (isQzone) {
    rs = 'qzone';
  } else if (isWX) {
    rs = 'wx';
  }

  return rs;
})();

export const platform = (function() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/windows phone/i.test(userAgent)) {
    return 'wp';
  }

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  return 'pc';
})();

export const getToken = (function() {
  let tmpSkey = null;
  let tmpToken = null;

  return function() {
    let skey = cookie('p_skey') || cookie('skey') || '';
    let hash = 5381;
    let token = tmpToken;

    if (skey) {
      //只有缓存中的skey失效时才重新生成gtoken
      if (skey !== tmpSkey) {
        tmpSkey = skey;
        let i = 0,
          l = skey.length;
        for (; i < l; ++i) {
          hash += (hash << 5) + skey.charAt(i).charCodeAt();
        }
        tmpToken = token = hash & 0x7fffffff;
      }
    } else {
      //不存在skey时,不需要token
      //不需要token的时候传空的就好了, null兼容性有问题
      tmpToken = token = '';
    }

    return token;
  };
})();

export const getCheckType = function(encryptMethod) {
  if (encryptMethod === 'sha') {
    return CONST.CHECK_TYPE_SHA;
  } else {
    return CONST.CHECK_TYPE_MD5;
  }
};

export const reportMd = function(mdInfo = {}, opt = {}) {
  // 必选参数判断
  if (!mdInfo || !mdInfo.interfaceId) return;

  mdInfo.fromId = mdInfo.fromId || '204971707';
  mdInfo.toId = mdInfo.toId || '204973141';

  if (Math.random() >= (opt.rate || 1)) return;
  new Image().src =
    'https://h5.qzone.qq.com/report/md?' + toUrlParams(mdInfo) + '&r=' + Math.random();
};

export const getUploadVoiceInfo = function(params) {
  params = params || {};

  if (params.iUploadType === 2) {
    params.format = params.format || {};
    params.voice_length = params.voice_length || 0;

    let format = 1,
      appid = 1000027;

    if (params.format.indexOf('amr') !== -1) {
      format = 1;
    } else if (params.format.indexOf('mp3') !== -1) {
      format = 2;
    }

    if (client == 'qq') {
      appid = 1000027;
    } else if (client == 'qzone') {
      appid = 65538;
    }

    let info = {
      uin: getUin() + '',
      format: format, // amr是1 mp3是2
      appid: appid,
      data: {},
      voice_length: params.voice_length,
      client_ip: 0,
      server_ip: 0,
      key_type: 0,
      key_value: {},
    };

    return info;
  }

  // 其他的透传
  return params;
};

export const getUploadPicInfo = function(params) {
  params = params || {};

  let info = {
    sPicTitle: params.sPicTitle || '',
    sPicDesc: params.sPicDesc || '',
    sAlbumName: params.sAlbumName || '',
    sAlbumID: params.sAlbumID || '',
    iAlbumTypeID: params.iAlbumTypeID ? params.iAlbumTypeID : params.sAlbumID ? 0 : 7, // 没有填 album 并且没有 albumid 则，上传到默认相册类型 7
    iBitmap: params.iBitmap || 0,
    iUploadType: params.iUploadType || 0, // 0 普通上传 1 大图 1200规格 2 高清 1600规格 3 原图上传
    iUpPicType: params.mutliPicInfo && params.mutliPicInfo.iBatUploadNum > 1 ? 1 : 0, // 0 表示单张上传 1 表示多图上传
    iBatchID: params.iBatchID || +new Date() * 1000,
    mutliPicInfo: params.mutliPicInfo || {},
    iPicWidth: params.iPicWidth || 0,
    iPicHight: params.iPicHight || 0,
    iWaterType: params.iWaterType || 0,
    iNeedFeeds: params.iNeedFeeds || 0,
    iUploadTime: params.iUploadTime || +new Date(),
    iDistinctUse: params.iDistinctUse || 0,
    stExtendInfo: params.stExtendInfo || {},
    stExternalMapExt: params.stExternalMapExt || {},
    mapExt: params.mapExt || {},
    iBusiNessType: params.iBusiNessType,
    vBusiNessData: params.vBusiNessData,
  };

  if (params.meta) {
    info.sExif_CameraMaker =
      (params.meta.tiff && params.meta.tiff.Make && String(params.meta.tiff.Make.value)) || '';
    info.sExif_CameraModel =
      (params.meta.tiff && params.meta.tiff.Model && String(params.meta.tiff.Model.value)) || '';
    info.sExif_Time =
      (params.meta.exif &&
        params.meta.exif.DateTimeOriginal &&
        String(params.meta.exif.DateTimeOriginal.value)) ||
      '';
    info.sExif_LatitudeRef =
      (params.meta.gps &&
        params.meta.gps.GPSLatitudeRef &&
        String(params.meta.gps.GPSLatitudeRef.value)) ||
      '';
    info.sExif_Latitude =
      (params.meta.gps &&
        params.meta.gps.GPSLatitude &&
        gpsArr2Num(params.meta.gps.GPSLatitude.value)) ||
      '';
    info.sExif_LongitudeRef =
      (params.meta.gps &&
        params.meta.gps.GPSLongitudeRef &&
        String(params.meta.gps.GPSLongitudeRef.value)) ||
      '';
    info.sExif_Longitude =
      (params.meta.gps &&
        params.meta.gps.GPSLongitude &&
        gpsArr2Num(params.meta.gps.GPSLongitude.value)) ||
      '';
  }

  return info;
};

export const gpsArr2Num = function(arr) {
  if (!arr || arr.length != 3) {
    return '';
  }
  return (
    arr[0].num / arr[0].den +
    arr[1].num / arr[1].den / 60 +
    arr[2].num / arr[2].den / 3600
  ).toFixed(6);
};

/**
 * 获取 jpeg 文件的 meta
 */
export const getImageMeta = function(file, callback, opt) {
  opt = opt || {};
  if (opt.meta) {
    callback(opt.meta, null);
  } else {
    if (file.type === 'image/jpeg') {
      let r = new FileReader();
      let meta = null;
      r.onload = function(event) {
        let err = null;
        try {
          meta = new JpegMeta.JpegFile(event.target.result, file.name);
        } catch (ex) {
          err = ex;
        }

        callback(meta, err);
      };

      r.onerror = function(event) {
        callback(meta, event.target.error);
      };

      if (r.readAsBinaryString) {
        r.readAsBinaryString(file);
      } else {
        callback(meta, 'no readAsBinaryString');
      }
    } else {
      callback(null, 'not JPEG');
    }
  }
};

export const isSameOrigin = function(url) {
  let loc = window.location;
  let a = document.createElement('a');

  a.href = url;

  return a.hostname == loc.hostname && a.port == loc.port && a.protocol == loc.protocol;
};

export const flatObj = function(data) {
  let _result = {};

  let _flat = function(preKey, d) {
    let key, k;

    if (!isObject(d) && !isArray(d)) {
      if (!preKey) {
        _result = d;
      } else {
        _result[preKey] = d;
      }

      return;
    }

    for (key in d) {
      k = (!!preKey ? preKey + '.' : '') + (isArray(d) ? '_Array' : '') + key;

      _flat(k, d[key]);
    }
  };

  _flat('', data);

  return _result;
};

export const getAndroidVersion = function(ua) {
  ua = (ua || navigator.userAgent).toLowerCase();
  let match = ua.match(/android\s([0-9\.]*)/);
  return match ? match[1] : false;
};

export const supportWebSocket = (function() {
  let support;
  const noWebsocket = location.href.indexOf('__uploadNoWS=1') !== -1;

  return () => {
    if (noWebsocket) {
      return false;
    }

    if (support !== undefined && support !== null) {
      return support;
    }

    // weishi webview 用 websocket 会卡死，先关掉
    // support = !!window.WebSocket && navigator.userAgent.indexOf('WEISHI') === -1;
    support = !!window.WebSocket;
    support = support && !isIE();

    return support;
  };
})();

export const supportFormData = (() => {
  let support;
  const noFormData = location.href.indexOf('__uploadNoFormData=1') !== -1;

  return () => {
    if (noFormData) {
      return false;
    }

    if (support !== undefined && support !== null) {
      return support;
    }

    support = !!window.FormData;

    if (platform === 'android') {
      // android 4.3 以下 formdata 容易报错
      support = support && parseFloat(getAndroidVersion()) > 4.3;
    }

    // PC QQ webview 发 formdata 偶现 content-length 错误导致收到出错，这里直接用 json 好了
    if (isPCQQ()) {
      support = false;
    }

    return support;
  };
})();

export const isPCQQ = () => {
  let ua = navigator.userAgent || '';
  if (ua.indexOf('QQ/') > -1 && ua.indexOf('QQBrowser/') > -1) {
    return true;
  }

  return false;
};

export const supportWasm = (() => {
  let support;
  const noWasm = location.href.indexOf('__uploadNoWasm=1') !== -1;

  return () => {
    if (noWasm) {
      return false;
    }

    if (support !== undefined && support !== null) {
      return support;
    }

    try {
      if (
        typeof window.WebAssembly === 'object' &&
        typeof window.WebAssembly.instantiate === 'function'
      ) {
        const module = new window.WebAssembly.Module(
          Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00),
        );
        if (module instanceof window.WebAssembly.Module) {
          support = new window.WebAssembly.Instance(module) instanceof window.WebAssembly.Instance;
        }
      }

      if (support) {
        sha1Wasm.init();
      }
    } catch (e) {}

    return support;
  };
})();

export const getEncryptChunkSize = (function() {
  let size = 2048;

  return size;
})();

export const getUploadLimit = (function() {
  let limit = 20;

  return limit;
})();

export const getWebsocketCount = (function() {
  let count = 4;

  return count;
})();

export const getWebsocketLimit = (function() {
  let limit = getWebsocketCount * 5;

  return limit;
})();

export const domain = (function() {
  let hostname = location.host;
  let hostSplit = hostname.split('.');
  let domain2 = hostSplit.slice(-2).join('.');
  let domain3 = hostSplit.slice(-3).join('.');

  return {
    qq: domain2 === 'qq.com',
    qzone: domain3 === 'qzone.qq.com',
  };
})();

export const getHost = function() {
  const host = location.host || '';
  const hostList = ['h5.qzone.qq.com', 'h5.weishi.qq.com'];

  return `${hostList.indexOf(host) !== -1 ? host : hostList[0]}`;
};

export const report007 = function(command, type, retcode, cost) {
  // command = 'CLIENT_' + command;
  // const url =
  //   'https://report.qqweb.qq.com/report/007' +
  //   '?app=' +
  //   encodeURIComponent('qzone-web/upload') +
  //   '&url=' +
  //   encodeURIComponent(command) +
  //   '&type=' +
  //   type +
  //   '&httpcode=200' +
  //   '&retcode=' +
  //   retcode +
  //   '&cost=' +
  //   cost +
  //   '&_dc=' +
  //   Math.random();
  // new Image().src = url;
};

// https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
export const isIE = function() {
  // Internet Explorer 6-11
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;

  return isIE;
};
